import { INITIALIZE_FORM } from '../actionTypes';
import { privateDocumentsActions } from '../reducer';

export default (values) => privateDocumentsActions[INITIALIZE_FORM](values);
